export interface PositionData
{
    timestamp: string;
    latitude: number|null;
    longitude: number|null;
    heading: number|null;
}

export enum ShipType {
    PassengerCarrier = "6",
    Cargo = "7",
    Tanker = "8",
    Fishing = "30",
    TugCategoryOne = "31",
    TugCategoryTwo = "32",
    TugCategoryThree = "52" // Icebreaker, Inland Tug, Pusher Tug
}

export interface VesselPositionData
{
    imo: number;
    vesselName: string;
    timestamp: string;
    latitude: number|null;
    longitude: number|null;
    heading: number|null;
    course: number | null;
    sog: number | null;
    source: string; // data source e.g. Spire
    dataSources?: { [index:string]: PositionData };
    readingType: string; // AIS source e.g. Terrestrial
    navStatus: string; // AiS status e.g. Achored
    vesselWidth: number;
    vesselLength: number;
    mds?: Mds;
    etaScheduled: string; // ETA for current port according to latest AIS data
    etaCalc: string; // calculated ETA for next port (unfortunate naming - hard to change due to many apis depend on it)
    currUnlocode: string; // current port
    nextUnlocode: string; // next port
    lastEtd?: Date;
    lastUnlocode?: string;
    vesselType: ShipType | string;
    distanceCalc?: number;
    draught?: number;
    lifeboats?: number;
    mmsi?: number;
    vesselClass: string;
    vesselDesc?: string;
    vesselFlag?: string;
    vesselGrt?: number;
    vesselSummary?: string;
    callSign?: string;
    ownershipType?: string;
    vesselYear?: number;
    createdAt?: string;
    rot?: number;
    routeType?: string | null;
}

export enum VesselCategories {
    Alarm = "alarm",
    Maersk = "maersk",
    NonMaersk = "non-maersk",
    ContainerCargo = "Container_Cargo",
    Tug = "Tug",
    Tanker = "Tanker",
    RoRo = "Ro-Ro",
    BulkCarrier = "Bulk_Carrier",
    Other = "Other"
}

export type VesselCategory = VesselCategories.ContainerCargo
                            | VesselCategories.Tug
                            | VesselCategories.BulkCarrier
                            | VesselCategories.Tanker
                            | VesselCategories.RoRo
                            | VesselCategories.Other;

export interface VesselPositionDataExtended extends VesselPositionData {
    isMaersk: boolean;
    vesselCategory: VesselCategory;
}

export interface PositionDataWithSource extends PositionData
{
    source: string;
}

export interface VesselTrackData
{
    positions: PositionDataWithSource[];
    manualOverride?: boolean; // Only present on vessels
}

export const enum MdsStatus {
    OUTFLEETED = "OUTFLEETED"
}

export interface Mds {
    basic?: {
        status?: MdsStatus,
        name?: string,
        vesselClass?: string,
        fuelClass?: string,
        ownershipType?: string,
        fleetGroup?: string,
        builtDate?: Date,
        buildingYardName?: string,
        callSign?: string,
        flagState?: string,
        countryOfRegistry?: string,
    },
    comms?: Channels[],
    operator:{
        code?:string,
        name?:string,
        vesselCode?:string,
        vesselClass?:string,
        inFleetDate?:string,
    },
    general?: {
        primaryReportingTool?: number;
        primaryVoyagePlanningTool?: number;
    }
}

export type Channels = {
    type: string,
    identity: string,
    value: string
}

//Vessels with Premium version installed
export const PremiumVesselsList = [
    9120865,
    9162215,
    9166792,
    9175781,
    9190731,
    9190743,
    9190755,
    9190767,
    9190779,
    9190781,
    9192442,
    9192454,
    9192466,
    9192478,
    9193240,
    9193264,
    9193276,
    9198575,
    9215177,
    9215189,
    9215191,
    9215878,
    9215880,
    9215907,
    9215919,
    9220885,
    9220897,
    9222118,
    9231470,
    9245744,
    9245756,
    9245768,
    9245770,
    9251614,
    9251626,
    9251638,
    9273923,
    9273961,
    9283186,
    9283198,
    9283203,
    9283215,
    9283239,
    9289180,
    9289922,
    9289946,
    9294379,
    9294381,
    9294393,
    9299927,
    9299939,
    9302877,
    9302889,
    9302891,
    9305300,
    9308637,
    9308649,
    9313905,
    9313917,
    9313955,
    9315214,
    9315226,
    9315238,
    9315240,
    9315252,
    9318319,
    9320233,
    9320245,
    9320257,
    9321483,
    9321495,
    9321500,
    9321512,
    9321524,
    9321536,
    9321548,
    9321550,
    9334662,
    9334686,
    9342499,
    9342504,
    9342516,
    9342528,
    9343077,
    9348053,
    9348065,
    9348077,
    9348089,
    9348091,
    9348106,
    9348156,
    9348168,
    9348170,
    9348651,
    9352004,
    9352016,
    9352028,
    9352030,
    9352042,
    9355288,
    9355331,
    9355343,
    9355355,
    9355367,
    9356086,
    9356098,
    9356103,
    9356115,
    9356127,
    9356139,
    9356165,
    9357949,
    9357951,
    9357963,
    9357975,
    9359002,
    9359014,
    9359026,
    9359038,
    9359040,
    9359052,
    9392925,
    9394870,
    9394882,
    9394894,
    9402029,
    9408956,
    9409352,
    9411367,
    9411379,
    9411381,
    9425382,
    9430363,
    9430375,
    9430387,
    9430399,
    9444716,
    9444728,
    9444730,
    9444742,
    9444845,
    9456757,
    9456769,
    9456771,
    9456783,
    9456991,
    9457000,
    9458030,
    9458078,
    9458080,
    9458092,
    9459632,
    9484560,
    9484572,
    9525285,
    9525297,
    9525302,
    9525314,
    9525326,
    9525338,
    9525340,
    9525352,
    9525364,
    9525376,
    9525388,
    9525390,
    9525405,
    9525455,
    9525467,
    9525479,
    9525481,
    9525493,
    9526459,
    9526875,
    9526887,
    9526899,
    9526904,
    9526916,
    9526928,
    9526930,
    9526942,
    9526954,
    9526966,
    9526978,
    9527025,
    9527037,
    9527049,
    9527051,
    9527063,
    9529255,
    9561485,
    9561497,
    9619907,
    9619919,
    9619921,
    9619933,
    9619945,
    9619957,
    9619969,
    9619971,
    9619983,
    9619995,
    9622203,
    9622215,
    9622227,
    9622239,
    9622241,
    9622253,
    9632064,
    9632090,
    9632105,
    9632117,
    9632129,
    9632131,
    9632143,
    9632155,
    9632167,
    9632179,
    9694579,
    9697014,
    9697026,
    9699189,
    9699191,
    9699206,
    9761011,
    9775737,
    9775749,
    9775751,
    9775763,
    9775775,
    9778533,
    9778545,
    9778791,
    9778806,
    9778818,
    9778820,
    9778832,
    9778844,
    9780445,
    9780457,
    9780469,
    9780471,
    9780483,
    9784257,
    9784269,
    9784271,
    9784283,
    9784295,
    9784300,
    9784312,
    9784324,
    9784336,
    9786750,
    9786762,
    9786774,
    9786786,
    9848948,
    9848950,
    9885130,
    9885142,
    9885154,
    9885166,
    9885178,
    9944546,
    9948748,
    9948750,
    9948762,
    9948774,
    9948786,
    9948798,
    9283227,
    9694581,
    9294161,
    9948803,
    9948815,
    9401697
]

